import { ICategory } from "@eventr/common";
import { TEventrIcons } from "@eventr/common-storybook";
import { Stack } from "@mui/material";
import { cardTranslation } from "i18n/translateHelpers";
import { useBoundStore } from "state/bound.store";
import { RowInfoStandart } from "./RowInfoStandart";
import { SectionHeader } from "./sectionHeader";
import { onSkin } from "state/themeState/skin-colour";
interface ICategoryListProps {
  categories?: string[];
}

export const CategoryList = ({ categories }: ICategoryListProps) => {
  // See itinTagsList: defaulting inside the selector returns a new array each call, which
  // useShallow reads as a change and loops.
  const orgCategories = useBoundStore((s) => s.orgConfig?.categories);
  if (!categories || categories.length === 0) {
    return null;
  }
  if (!categories || categories.length === 0) return null;

  const categoryList: ICategory[] = [];
  categories.forEach((cat) => {
    const category = orgCategories?.find((c) => c.pub_id === cat);
    if (category) {
      categoryList.push(category);
    }
  });
  if (!categoryList || categoryList.length === 0) return null;

  return (
    <Stack spacing="8px">
      <SectionHeader title={cardTranslation("Categories")} />
      {categoryList.map((cat) => {
        return (
          <RowInfoStandart
            key={cat.id}
            middle={cat.name}
            icon={cat.icon as TEventrIcons}
            bubbleColour={onSkin(cat.colour)}
          />
        );
      })}
    </Stack>
  );
};
